export { default } from './BorrowingEmptyContentPanel';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingEmptyContentPanel/index.js